import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        textAlign: 'center',
        backgroundColor: '#e8edf2',
        position: 'fixed',
        left: 0,
        bottom: 0,
        p: 1,
        height: 35,
        color: 'black',
      }}
    >
      <Typography variant="body2">© {year} Metro Fresh. All rights reserved.</Typography>
    </Box>
  );
};

export default Footer;
